export default __webpack_public_path__ + "static/media/establecimiento.f3c1457a.svg";